import { IconToggleButton, LuIcon } from "@overmap-ai/blocks"
import { type ComponentPropsWithRef, memo, useCallback } from "react"

import { useEditorFocused, useFallbackEditor, useOrderedListState } from "../../hooks"
import { tipTapIconMapping } from "../mappings"
import type { OptionalEditorProps } from "../typings"

interface OrderedListToggleButtonProps
	extends Omit<ComponentPropsWithRef<typeof IconToggleButton>, "children">, OptionalEditorProps {}

export const OrderedListToggleButton = memo<OrderedListToggleButtonProps>((props) => {
	const { ref, editor: editorFromProps, pressed, onPressedChange, disabled, ...rest } = props

	const editor = useFallbackEditor(editorFromProps)
	const isEditorFocused = useEditorFocused(editor)
	const state = useOrderedListState(editor)

	const handlePressedChange = useCallback(
		(pressed: boolean) => {
			onPressedChange?.(pressed)
			editor?.chain().focus().toggleOrderedList().run()
		},
		[editor, onPressedChange],
	)

	return (
		<IconToggleButton
			ref={ref}
			pressed={pressed ?? (state.isActive && isEditorFocused)}
			onPressedChange={handlePressedChange}
			disabled={disabled ?? !state.canToggle}
			{...rest}
		>
			<LuIcon icon={tipTapIconMapping.orderedList} />
		</IconToggleButton>
	)
})
OrderedListToggleButton.displayName = "OrderedListToggleButton"
